// extracted by mini-css-extract-plugin
export default {"LeadsHealthIssues__list":"zDBBKLIHPscXSat1WnWp","LeadsHealthIssues__item":"OIEiwwCmWQVE3VHmxHKM","LeadsHealthIssues__txtbox":"EEyoM4C1tvYVOH1WlcH5","LeadsHealthIssues__imgbox":"pUANQfLbKRTCB5lmEr4X","LeadsHealthIssues__img":"lN3AJjqWaQi4pKD2nZtu","LeadsHealthIssues__btnbox":"toYKyud2HimedSAdUDwb","LeadsHealthIssues__UpdateItem":"gqFo4E7EVnKIKdCcGATK","redfill_animate":"JZyIIOwxMOV9nyfMyc1Q","Accordion__Contant__Button":"vkEt4WfArBsii1MhTcAs","bluefill_animate":"CeC2kPVL40SiVg0ersjq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"LeadsHealthIssues__list\":\"zDBBKLIHPscXSat1WnWp\",\"LeadsHealthIssues__item\":\"OIEiwwCmWQVE3VHmxHKM\",\"LeadsHealthIssues__txtbox\":\"EEyoM4C1tvYVOH1WlcH5\",\"LeadsHealthIssues__imgbox\":\"pUANQfLbKRTCB5lmEr4X\",\"LeadsHealthIssues__img\":\"lN3AJjqWaQi4pKD2nZtu\",\"LeadsHealthIssues__btnbox\":\"toYKyud2HimedSAdUDwb\",\"LeadsHealthIssues__UpdateItem\":\"gqFo4E7EVnKIKdCcGATK\",\"redfill_animate\":\"JZyIIOwxMOV9nyfMyc1Q\",\"Accordion__Contant__Button\":\"vkEt4WfArBsii1MhTcAs\",\"bluefill_animate\":\"CeC2kPVL40SiVg0ersjq\"}";
        // 1779800065511
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  